<template>
<div>
     <div :id="index"
      v-for="(type,index) in hotelRoomImage" :key="index+'type'">
   
       <cContentEdit 
      :canEdit="true"
      :editMode="true"
      :title="index"
      :needCancel="false"
      :toDelete="index=='Room Main Image'?false:true"
      @toDeleteCard="toRemovetheCard(index)"
     :key="`${contentKey}-${index}`"
      
    >
    <!-- <div class="card assign pricing-card"> -->
       <cImages 
       @getEncodedImages="getImageFile"
       @toDeleteImg="deleteHotelImage"
       :allowImagePreview="true"
       :allowMultiple="index=='Room Main Image'?false:true"
       :allowBrowse="true"
       :allowFileEncode="true"
       :allowImageTransform="true"
       :reference="index"
       :typeImg="type"
       :galleryShow="true"
       :imageUrl="imageUrl[index]"
       :toShow="index=='Room Main Image' && type[0].hasOwnProperty('imageid')? false:true"
       :editMode="true"
       :imageIndex="index"
       >
       <template #imagesdisplay>
          
       </template>
    </cImages>
    <div :show="type[0].alertValue" v-if='type[0].alertValue'
       class="err-msg" :class="'danger'">
        {{type[0].alertValue}}
       <div @click='closeAlertValue(index)' class='align-alert'>
        <CIcon   name="cilXCircle">
        </CIcon>
       </div>
     </div> 
     <!-- </div> -->
    </cContentEdit>

         </div>
         <label><strong>Add Room Image Type</strong></label>
         <br />
             <multiselect 
     v-model="selType" 
     tag-placeholder="Add this as new Image type" 
     placeholder="Add Image Type" 
     label="name" 
     track-by="code" 
     v-on:input="toAddToImageType"
     :options="options" 
      :taggable="true" 
       @tag="addOptionToLs"
     ></multiselect>
      <CCardFooter v-if="alert && alert.value ">
      <CAlert :color="alert.color" closeButton>{{ alert.value }}</CAlert>
    </CCardFooter>
    <!-- <CCardFooter>
      <CAlert v-if="alertValue" show color="danger">{{alertValue}}</CAlert>
    </CCardFooter> -->
     <cAlertModal
              v-if="isShowAlertModal"
              :key="'CA'+alertCount"
              :buttonList="modalButton"
              :status="modalStatus"
              :isShowIcon="true"
              :show="isShowAlertModal"
              :desc="confirmTxt"
            ></cAlertModal>
</div>
</template>
<script>
import {
  COMPONENT_NAME,
  PATHNAME,
  ROOM_IMAGE_TYPES,ALERT_MODAL_STATUS, 
} from "../../../../util/constants";
import {
  LOG_TYPE,
  FILE_NAME,
  HTTP_CODES,
  API_VALUES,
} from "../../../../config/API_DATA";
import BaseConfiguration from "../../../../config/base";
import Logger from "../../../../services/logger";
import { mapGetters, mapActions } from "vuex";
import cTextInputComponent from "../../../../components/form/cTextInputComponent";
import apiGetHotelRoomImage from "../../../../services/apiGetHotelRoomImage";
import apiUpdateHotelRoomImage from "../../../../services/apiUpdateHotelRoomImage";
import apiDeleteHotelRoomImage from "../../../../services/apiDeleteHotelRoomImage";
import cContentEdit from "../../../../components/hms/manage/hotelInfo/cContentEdit";
import {
  VALIDATE_SUCCESS_RES,
  getErrorMessage,
} from "../../../../util/apiValidate";
import {
  handleJWT,
  getErrorAlertValue,
  addClassToBody,
  removeClassBody,
  OrderByList,
  groupBy,
  cloneDeep,cloneData
} from "../../../../util/util";
import multiselect from "vue-multiselect";
import cAlertModal from "../../../../components/form/cAlertModal";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import cImages from '../../../../components/hms/manage/hotelInfo/cImages';
import Vue from "vue";
export default {
     name: COMPONENT_NAME.C_ROOM_IMAGES,
  components: {
    cContentEdit,
    cTextInputComponent,
    ValidationObserver,
    ValidationProvider,
    cImages,
    multiselect,
    cAlertModal
  },
  
  data: () => {
    return {
      myFiles: [],
      imageUrl:{},
      imageObj: {
        image: null,
        type: null,
        isMainImage: null,
        sortOrder: 0,
      },
      alertValue: null,
      hotelRoomImage: null,
      alert: {
        value: null,
        color: null,
      },
     contentEdit:true,
    isShowAlertModal: false,
      confirmTxt:null,
      alertCount:0,
      alertValue: null,
      modalAlert:null,
      showDp:false,
      selType: null,
      options:[],
      imageLs:[],
      contentKey:1
    };
  },
  props: {
    showEdit: {
      type: Boolean,
      default: false,
    },
    roomid: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters("shmsManage", {
      hotelObj: "GET_SEL_HOTEL",
    }),
     ...mapGetters("sHotelInfo", {
      sRoomObj: "GET_HOTEL_ROOM_OBJ"
    })
  },
  methods:{
       showAlert(val, isSuccess) {
      this.alert.value = val;

      this.alert.color = isSuccess ? "success" : "warning";
    },
      getImageFile(pImgObj,isDeleted) {
      let sortOrder;
      if(pImgObj){
     
      if(isDeleted){
        for (let i = 0; i < this.imageLs.length; i++) {
       if(this.imageLs[i].fileName == pImgObj.filenameWithoutExtension) {
         this.$delete(this.imageLs,i);
         break;
       }
         } 
      }else{
        for (let i = 0; i < pImgObj.length; i++) {
        this.imageLs.push(pImgObj[i])
      }
      }
      if(pImgObj && pImgObj instanceof Array){
      pImgObj.filter((item, index) => {
            if(item.type == 'Room Main Image'){
              this.$emit('isMainImageUploaded',true)
              
            }
          });
      }else if(pImgObj instanceof Object && pImgObj.type == 'Room Main Image'){
        this.$emit('isMainImageUploaded',false)
      }
        console.log(this.imageLs)
      } else {
        this.hotelRoomImage[ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE][0].alertValue='You can add only one image in main hotel image'
      }

    },

    async getHotelRoomImage() {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("getHotelRoomImage");

        if (this.hotelObj) {
          let hotelImageReq = apiGetHotelRoomImage.buildRequest(
            this.hotelObj.hotelid,this.roomid
          );

          if (hotelImageReq) {
            let hotelImageRes = await apiGetHotelRoomImage.getResponse(
              hotelImageReq
            );

            if (VALIDATE_SUCCESS_RES(hotelImageRes)) {
              this.showAlert(null);
              retValue = hotelImageRes.data.data.list;
            } else {
              let error = getErrorMessage(hotelImageRes);

              let isJwt = handleJWT(error);
              if (!isJwt) {
                let alertValue = getErrorAlertValue(error, true, true);
              }
            }
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_ROOM_IMAGES,
          "error in getHotelRoomImage",
          err.toString(),
          "getHotelRoomImage",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    isValidImages(pImages) {
       let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("isValidImages");
         let hotelImage = JSON.parse(
            JSON.stringify(groupBy(pImages, "type"))
          );
          let hasImg=false;
          for(var j in this.hotelImage){
             if(j==ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE && this.hotelImage[j][0].hasOwnProperty('imageType')){
               hasImg = true;
               retValue=true;
               break;
             }
          }
          if(!hasImg){
          for(var i in hotelImage){
            if(i==ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE){
              if(hotelImage[i].length>1){
                retValue=false;
                break;
              }else{
                retValue=true;
              }
            }else{
                retValue=true;
              }
          }
        }
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_ROOM_IMAGES,
                  "error in isValidImages",
                  err.toString(),
                  "isValidImages",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
    }, 


      async updateHotelRoomImage(pRoomid) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("updateHotelRoomImage");
        let imageLS =  JSON.parse(
            JSON.stringify(groupBy(this.imageLs, "type"))
          );
          for(var i in imageLS){
            this.updateHotelImage(i,pRoomid);
          }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_ROOM_IMAGES,
          "error in updateHotelRoomImage",
          err.toString(),
          "updateHotelRoomImage",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },


    async updateHotelImage(type,pRoomid) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("updateHotelImage");
        
        let tempimageLs=[]
        for (let j = 0; j < this.imageLs.length; j++) {
          if(type==this.imageLs[j].type) {
            tempimageLs.push(this.imageLs[j])
          }
          
        }
        let validImage = this.isValidImages(tempimageLs)
        
        if (tempimageLs.length!=0 && this.hotelObj && validImage) {
           if(this.hotelRoomImage[tempimageLs[0].type][0].hasOwnProperty('imageid')){
               tempimageLs[0].sortOrder = this.hotelRoomImage[tempimageLs[0].type].length+1;
            }else if(!this.hotelRoomImage[tempimageLs[0].type][0].hasOwnProperty('imageid')){
              tempimageLs[0].sortOrder = this.hotelRoomImage[tempimageLs[0].type].length;
            }
          for (let index = 1; index < tempimageLs.length; index++) {
              tempimageLs[index].sortOrder = tempimageLs[0].sortOrder+index;
              // this.$delete(this.imageLs[index],'fileName')         
          }
           for (let i = 0; i < tempimageLs.length; i++) {
          if (tempimageLs[i].image != null) {
            
            let updateRequest = apiUpdateHotelRoomImage.buildRequest(
              tempimageLs[i],pRoomid,
              this.hotelObj.hotelid
            );

            if (updateRequest) {
              let updateRes = await apiUpdateHotelRoomImage.getResponse(
                updateRequest
              );

              if (VALIDATE_SUCCESS_RES(updateRes)) {
                // this.showAlert("updated Successfully", true);
                retValue = updateRes.data.data;
               
                this.$emit('isImageUpdated',true)
              } else {
                let error = getErrorMessage(updateRes);
                this.showAlert(error, false);
                let isJwt = handleJWT(error);
                if (!isJwt) {
                 let alertValue = getErrorAlertValue(error, true, true);
                  this.hotelRoomImage[type][0].alertValue = alertValue;
                  // this.$root.$emit('ImagealertValue',false);
                }
                
              }
            }
          } 
        }
       
        
        
        
        }else if(!validImage && tempimageLs.length!=0){
          if(type==ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE){
            this.hotelRoomImage[ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE][0].alertValue = "You can add only one image in main hotel image";
          }
         
          }
          else if(tempimageLs.length==0 && !this.hotelRoomImage[type][0].hasOwnProperty('imageid')){
            this.hotelRoomImage[type][0].alertValue = 'Select an image to upload'
             this.contentKey += 1;
            
          }else if(tempimageLs.length==0 && this.hotelRoomImage[type][0].hasOwnProperty('imageid')){
         
             this.hotelRoomImage[type][0].editMode=false;
          }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_ROOM_IMAGES,
          "error in updateHotelImage",
          err.toString(),
          "updateHotelImage",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

    async deleteHotelImage(img) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("deleteHotelImage");
        if (this.hotelObj) {
          let deleteRequest = apiDeleteHotelRoomImage.buildRequest(
            img,
            this.hotelObj.hotelid
          );

          if (deleteRequest) {
            let deleteRes = await apiDeleteHotelRoomImage.getResponse(
              deleteRequest
            );

            if (VALIDATE_SUCCESS_RES(deleteRes)) {
              this.showAlert("deleted Successfully", true);
              retValue = deleteRes.data.data;
             
            } else {
              let error = getErrorMessage(deleteRes);
              this.showAlert(error, false);
              let isJwt = handleJWT(error);
              if (!isJwt) {
                let alertValue = getErrorAlertValue(error, true, true);
              }
            }
             this.toGetHotelRoomImage(true,img.imageType);
          }
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_ROOM_IMAGES,
          "error in deleteHotelImage",
          err.toString(),
          "deleteHotelImage",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },

      scrollToElement(pRef) {
                var el = null;
               
                for(var i in this.$refs){
                    if(i==pRef){
                        el = this.$refs[i];
                        break;
                    }
                
                }
                if (el) {
                    if(el[0]){
                        el[0].scrollIntoView({ behavior: "smooth" });
                    }else{
                         el.scrollIntoView();//{ behavior: 'smooth' }
                    }
                   
                }
            },

            closeAlertValue(type){
               this.hotelRoomImage[type][0].alertValue=null;
                this.contentKey += 1;
      //          this.contentEdit=false;
      //         let that = this;
      // setTimeout(function() {
      //   that.contentEdit = true;
      // });
      //  setTimeout(function(){
      //           that.scrollToElement(type); 
      //       })
            },

      toggleEditMode(type) {
        try {
          if(BaseConfiguration.isDebug) console.log("toggleEditMode");
          // pEditModeOf.editMode = !pEditModeOf.editMode
          // if(!pEditModeOf.hasOwnProperty('imageUrlpath') && type!=ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE){
          //   this.toGetUrltoDelete(type);
          // }
           if(!this.hotelRoomImage[type][0].hasOwnProperty('imageUrlpath') && type!=ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE){
            this.toGetUrltoDelete(type);
            this.imageLs=[];
          } else if(!this.hotelRoomImage[type][0].hasOwnProperty('imageUrlpath') && type==ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE){
            this.hotelRoomImage[type][0].alertValue = 'Upload atleast one image'
          }else{
            this.hotelRoomImage[type][0].editMode = !this.hotelRoomImage[type][0].editMode
            this.hotelRoomImage[type][0].alertValue =null;
            this.imageLs=[];
          }
      
          
      //     this.contentEdit=false;
      //      let that = this;
      // setTimeout(function() {
      //   that.contentEdit = true;
      // });

      //  if(this.hotelRoomImage[type][0].editMode==true){
      // setTimeout(function(){
      //           that.scrollToElement(type); 
      //       })
      // }else{
      // }
      if(this.hotelRoomImage[type] && this.hotelRoomImage[type][0].editMode==false){
        // this.$emit('isImageSaved',true)
      }
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_ROOM_IMAGES,
                  "error in toggleEditMode",
                  err.toString(),
                  "toggleEditMode",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          
   }, 
    showAlertModal(status, val,pParam) {
      this.isShowAlertModal = true;
      this.alertCount += 1;
      this.modalStatus = status;

      if (status == ALERT_MODAL_STATUS.INFO) {
        this.modalButton = [
          {
            name: this.$t("cancellationNew.no"),
            func: this.toggleShowAlertModal,
          },
          {
            name: this.$t("cancellationNew.yes"),
            func: this.toGetUrltoDelete,
            param: pParam ? pParam : null
          },
        ];
      } else if (
        status == ALERT_MODAL_STATUS.SUCCESS ||
        status == ALERT_MODAL_STATUS.FAIL
      ) {
        this.modalButton = [
          {
            name: this.$t("cancellationNew.ok"),
            func: this.toggleShowAlertModal,
          },
        ];
      }
      this.confirmTxt = val;
    },
        toGetUrltoDelete(pParams) {
        try {
          if(BaseConfiguration.isDebug) console.log("toGetUrltoDelete");
          if(pParams){
             var optObj = {
            name: null,
            code: null
          }
                 optObj.name = pParams
           optObj.code= pParams.substring(0, 2);
           if(!this.options.includes(optObj)){
           this.options.push(cloneData(optObj));
           }
             if(this.hotelRoomImage[pParams][0].hasOwnProperty('imageid')){
            for (let i = 0; i < this.hotelRoomImage[pParams].length; i++) {
              let img = this.hotelRoomImage[pParams][i]
                 this.deleteHotelImage(img);
                 
            
                 this.isShowAlertModal = false;
              }
              }
              else{
                this.$delete(this.hotelRoomImage,pParams)
               this.isShowAlertModal = false;
              }
          }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_ROOM_IMAGES,
                  "error in toGetUrltoDelete",
                  err.toString(),
                  "toGetUrltoDelete",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
    }, 
    toggleShowAlertModal() {
      //  updateDataEdited(true);
      this.isShowAlertModal = !this.isShowAlertModal;
      this.modalStatus = ALERT_MODAL_STATUS.INFO;
    },
    toRemovetheCard(index) {
        try {
          if(BaseConfiguration.isDebug) console.log("toRemovetheCard");
          this.showAlertModal(
                ALERT_MODAL_STATUS.INFO,
                'Are you sure you want to remove the whole card?',index
              )
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_ROOM_IMAGES,
                  "error in toRemovetheCard",
                  err.toString(),
                  "toRemovetheCard",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
   }, 
     addOptionToLs(pSelOption) {
       let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("addOptionToLs");
          var optObj = {
            name: null,
            code: null
          }
          optObj.name = pSelOption
           optObj.code= pSelOption.substring(0, 2)
           if(!this.options.includes(optObj)){
            this.options.push(cloneData(optObj));
           }
            let selObj = [{editMode:true,alertValue:null}]
            this.hotelRoomImage[pSelOption]=[];
            this.hotelRoomImage[pSelOption] = cloneData(selObj);
            for (let i = 0; i < this.options.length; i++) {
          if(this.options[i].name==optObj.name){
          this.$delete(this.options,i)
          break;
          }
        }
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_ROOM_IMAGES,
                  "error in addOptionToLs",
                  err.toString(),
                  "addOptionToLs",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
    }, 

  toAddToImageType(pSelOption) {
       let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("toAddToImageType");
      
        if(!Object.keys(this.hotelRoomImage).includes(pSelOption.name)){
           let selObj = [{editMode:true,alertValue:null,key:pSelOption.name+1}]
            this.hotelRoomImage[pSelOption.name]=[];
            this.hotelRoomImage[pSelOption.name] = cloneData(selObj);
            
        }
        for (let i = 0; i < this.options.length; i++) {
          if(this.options[i].name==pSelOption.name){
          this.$delete(this.options,i)
          break;
          }
        }
            this.selType=null;
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_ROOM_IMAGES,
                  "error in toAddToImageType",
                  err.toString(),
                  "toAddToImageType",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
    }, 

    async toGetHotelRoomImage(isDelete,type) {
      let retValue;
      try {
        if (BaseConfiguration.isDebug) console.log("toGetHotelRoomImage");
        let hotelRoomImage = await this.getHotelRoomImage();
         var optObj = {
            name: null,
            code: null
          }
          for (var j in ROOM_IMAGE_TYPES.OPTIONS) {
            
           optObj.name = ROOM_IMAGE_TYPES.OPTIONS[j]
           optObj.code= ROOM_IMAGE_TYPES.OPTIONS[j].substring(0, 2)
           if(!this.options.includes(optObj)){
            this.options.push(cloneData(optObj));
          }
          }
        if (hotelRoomImage && hotelRoomImage.length != 0) {
        hotelRoomImage = JSON.parse(
            JSON.stringify(groupBy(hotelRoomImage, "imageType"))
          );
           var sortedLs={};
          var tempLs={};
          for(var i in hotelRoomImage){
            for (let optname = 0; optname < this.options.length; optname++) {
          if(this.options[optname].name==i){
          this.$delete(this.options,optname)
          break;
          }
        }
            let url=[]
            this.imageUrl[i]={
                    url:[],
                    index: null
                  };
                  if(!isDelete){
                  hotelRoomImage[i][0]["editMode"]=false;
                  }else{
                    if(i==type){
                    hotelRoomImage[type][0]["editMode"]=true;
                    } else{
                      hotelRoomImage[i][0]["editMode"]=false;
                    }
                  }
                  // hotelRoomImage[i][0]["editMode"]=false;
                  hotelRoomImage[i][0]["key"]=i+0;
                  hotelRoomImage[i][0]["alertValue"]=null;
                for (let img=0; img< hotelRoomImage[i].length; img++) {
                  if(hotelRoomImage[i][img].hasOwnProperty('ismainPhoto') &&
                   hotelRoomImage[i][img].ismainPhoto==true && i!=ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE) {
                    hotelRoomImage[ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE]=[]
                    
                    hotelRoomImage[ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE][0]=hotelRoomImage[i][img]
                    hotelRoomImage[ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE][0]["editMode"]=false;
                    hotelRoomImage[ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE][0]["alertValue"]=null;
                    this.$delete(hotelRoomImage[i],img)
                    img--;
                  }
                  else if(hotelRoomImage[i][img].hasOwnProperty('imageUrlpath') && (!hotelRoomImage[i][img].imageUrlpath 
                   || hotelRoomImage[i][img].imageUrlpath=="")){
                     this.$delete(hotelRoomImage[i],img);
                     img--;
                  }else{
                url.push(
                  hotelRoomImage[i][img].imageUrlpath
                );
                }
              }
                     this.contentEdit=false;
           let that = this;
      setTimeout(function() {
        that.contentEdit = true;
        
      });
               this.imageUrl[i].url=cloneData(url)
              

          }
          for(var obj in hotelRoomImage){
            if(obj==ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE){
                sortedLs[obj]=[]
                sortedLs[obj]=hotelRoomImage[obj];
              }else{
                tempLs[obj]=[]
                tempLs[obj]=hotelRoomImage[obj];
              }
          }
         if(Object.keys(sortedLs).length==0){
            // if(!Object.keys(this.hotelImage).includes(IMAGE_TYPES.OPTIONS.MAIN_IMAGE)){
               sortedLs[ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE]=[];
               let obj={editMode:true,alertValue:null}
            sortedLs[ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE][0]=cloneData(obj);
            // }
         }
          var finalLs= Object.assign(sortedLs,tempLs)
        
          var sortedFinalLs={}
         
          for(var fin in finalLs){
            if(finalLs[fin].length!=0){
              sortedFinalLs[fin] = [];
              sortedFinalLs[fin] = finalLs[fin];
            }
          }
          if(Object.keys(sortedFinalLs).length!=0){
          this.hotelRoomImage = sortedFinalLs;
          
          this.showDp = false;
          }else{
            this.hotelRoomImage = {};
          this.hotelRoomImage[ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE]=[];
          let obj={editMode:true,alertValue:null,key:ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE+1}
          for(var i in this.hotelRoomImage){
            this.hotelRoomImage[i][0]=cloneData(obj);
            // this.hotelRoomImage[i][0]={}
            // this.hotelRoomImage[i][0]["editMode"]=true;    
          }
          this.showDp = true;
          }
         
        } else {
          this.hotelRoomImage = {};
          this.hotelRoomImage[ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE]=[];
          let obj={editMode:true,alertValue:null,key:ROOM_IMAGE_TYPES.OPTIONS.MAIN_IMAGE+1}
          for(var i in this.hotelRoomImage){
              for (let optname = 0; optname < this.options.length; optname++) {
          if(this.options[optname].name==i){
          this.$delete(this.options,optname)
          break;
          }
        }
            this.hotelRoomImage[i][0]=cloneData(obj);
            // this.hotelRoomImage[i][0]={}
            // this.hotelRoomImage[i][0]["editMode"]=true;    
          }
          this.showDp = true;
        }
      } catch (err) {
        let body = Logger.buildRequest(
          COMPONENT_NAME.C_ROOM_IMAGES,
          "error in toGetHotelRoomImage",
          err.toString(),
          "toGetHotelRoomImage",
          LOG_TYPE.ERROR
        );
        Logger.getResponse(body);
      }
      return retValue;
    },
  },
   created() {
    this.toGetHotelRoomImage(false);
    
  },
}
</script>
<style lang="scss">
.err-msg{
  background: #ce0000;
  width:auto;
  height: 30px;
  display: flex;
  align-items: center;
  padding: 10px;
  //border-radius: 3px;
  color: white;
  position: absolute;
  top: 1px;
  right: 2px;
  padding-left: 33px;
}


</style>